import styled from "styled-components";
import ProfileIcon from "../../../components/ProfileIcon";
import { useActiveUsers } from "../../../hooks/ActiveUsersContext";
import { openProfileDisplayModal } from "../../../components/ProfileDisplay";

const ClickableProfileIcon = styled(ProfileIcon)`
    cursor: pointer;
    height: 32px;
    width: 32px;
    margin-top: auto;
    margin-bottom: auto;
`;

const AnalystIconDisplay = ({ analystId }) => {
    const { data: { results: users } } = useActiveUsers();
    const user = users && users.length > 0 ? users.find(el => el.id === analystId) : null;

    const onIconClicked = () => {
        openProfileDisplayModal(user).then(
            () => {},
            () => {}
        );
    };

    if (!user) return <span></span>

    return <ClickableProfileIcon user={user} isOnline={user?.isOnline} showOnlineStatusIndicator={false} onClick={onIconClicked} />
}

export default AnalystIconDisplay;